import React from "react";
import "../theme/Administracion.css";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { TableAdministracionRol } from "../components/TableAdministracionRol";
import { authProvider } from "../context/authProvider";
import { useNavigate } from "react-router-dom";

export const AdminPageRol = () => {
  const navigate = useNavigate();
  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <button className="button-goback-style" onClick={() => navigate(-1)}>
                    <ArrowBackIosIcon />
                  </button>
                  <div> Administración de Roles </div>
                </div>
              </div>
              <TableAdministracionRol />
            </div>
          );
        }
      }}
    </OktaIDP>
  );
};
